import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgProfileIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={12} cy={10} r={3} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M6 19c.429-1.333 2.229-4 6-4s5.571 2.667 6 4"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgProfileIcon);
const Memo = memo(ForwardRef);
export default Memo;
